import React, { MouseEventHandler, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomizedSelect from '../../core/CustomizedSelect/CustomizedSelect';
import { useForm } from '../../context/FormContext';
import { useComparatorVideo } from '../../context/ComparatorVideoContext';
import 'react-phone-number-input/style.css';
import './PriceComparator.css';
import { ReactComponent as InfoIcon } from '../../assets/images/info.svg';
import { Link } from 'react-router-dom';
import ModalLegalResumen from './ModalLegalResumen';
import { useAuth } from '../../context/AuthContext';
import { IconLock } from '../Icons';
import PopUp from '../../shared/PopUp/PopUp';
import Login from '../Login/Login';
import { IconUserLogged } from '../Icons/IconUserLogged';
import AvatarWomen from '../../assets/images/avatar-women.png';
import AvatarMen from '../../assets/images/avatar-men.png';
import { useAvatar } from '../../hooks/useAvatar';

interface Props {
	onComponentChange: () => void;
	onFullScreenChange: () => void; // Nueva prop para cambiar a pantalla completa
	handleClickOpen: MouseEventHandler<HTMLButtonElement>;
}

const PriceComparatorForm: React.FC<Props> = ({ handleClickOpen, onComponentChange, onFullScreenChange }) => {
	const { t } = useTranslation();
	const { state } = useAuth();
	const { formData, setFormData } = useForm();
	const options__unidades = ['kg'];
	const [productNameError, setProductNameError] = useState('');
	const [productPriceError, setProductPriceError] = useState('');
	const [volumeValueError, setVolumeValueError] = useState('');
	const [countries, setCountries] = useState(['']);
	const [openProduct, setOpenProduct] = useState(false);
	const { setComparatorVideo } = useComparatorVideo();
	const [showLoginPopup, setShowLoginPopup] = useState(false);
	const [showLoginRequiredPopup, setShowLoginRequiredPopup] = useState(false);
	const avatar = useAvatar();

	const data = [
		{
			producto: 'Frutos cubiertos con chocolate',
			productName: 'Frutos secos con chocolate',
			tipoDeEnvase: 'Caja cartón',
			posicionArancelaria: '1806103010',
			volumeValue: '0.500',
			productPrice: '4.75',
			countrySelection: 'Alemania, Francia, España, Italia',
		},
		{
			producto: 'Plant based Food',
			productName: 'Plant based food',
			tipoDeEnvase: 'Bandeja plástico con foto',
			posicionArancelaria: '1901909940',
			volumeValue: '0.150',
			productPrice: '4.62',
			countrySelection: 'Alemania, Australia, USA, Suecia',
		},
		{
			producto: 'Fideos sin gluten',
			productName: 'Fideos sin gluten',
			tipoDeEnvase: 'Caja cartón con ventana plástico',
			posicionArancelaria: '1901909939',
			volumeValue: '0.250',
			productPrice: '3.30',
			countrySelection: 'Alemania, Italia, USA, Francia, España',
		},
		{
			producto: 'Tabletas de chocolate',
			productName: 'Tabletas de chocolate',
			tipoDeEnvase: 'Ecopack',
			posicionArancelaria: '1901909939',
			volumeValue: '0.850',
			productPrice: '7.35',
			countrySelection: 'Alemania, España; Austria, Paises Bajos, Belgica',
		},
		{
			producto: 'Mieles envasada',
			productName: 'Mieles envasada',
			tipoDeEnvase: 'Frasco vidrio con tapa',
			posicionArancelaria: '1901909939',
			volumeValue: '0.500',
			productPrice: '6.00',
			countrySelection: 'Alemania, Nueva Zelanda; Austria',
		},
		{
			producto: 'Salsas y aderezos (envasadas)',
			productName: 'Salsas y aderezos (envasadas)',
			tipoDeEnvase: 'Botella PET estrujable',
			posicionArancelaria: '1901909939',
			volumeValue: '0.250',
			productPrice: '3.40',
			countrySelection: 'Alemania, USA, Francia, UK',
		},
	];

	const handleChange = (field: keyof typeof formData, value: string | string[]) => {
		setFormData((prev) => ({ ...prev, [field]: value }));
	};

	const handleUnidadChange = (value: string) => {
		setFormData((prevFormData) => ({
			...prevFormData,
			unidad: value,
		}));
	};

	const handleSubmit = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
		let isValid = true;

		if (formData.productName.trim() === '') {
			setProductNameError(t('price_comparator.step_1.message_1'));
			isValid = false;
		} else if (formData.productName.trim().length < 3) {
			setProductNameError(t('price_comparator.step_1.message_2'));
			isValid = false;
		} else {
			setProductNameError('');
		}

		if (Number(formData.productPrice) <= 0 || isNaN(Number(formData.productPrice))) {
			setProductPriceError(t('price_comparator.step_1.message_3'));
			isValid = false;
		} else {
			setProductPriceError('');
		}

		if (Number(formData.volumeValue) <= 0 || isNaN(Number(formData.volumeValue))) {
			setVolumeValueError(t('price_comparator.step_1.message_3'));
			isValid = false;
		} else {
			setVolumeValueError('');
		}

		if (isValid) {
			onComponentChange();
			onFullScreenChange();
		}
	};

	const handleChangeButton = (id: number) => {
		if (!state?.isAuthenticated && id != 0) {
			setShowLoginRequiredPopup(true);
			return;
		}

		window.scrollTo({ top: 0, behavior: 'smooth' });
		setComparatorVideo(id);
		setOpenProduct(true);
		if (data[id]?.countrySelection) {
			setCountries(data[id]?.countrySelection?.split(','));
		}

		setFormData({
			id,
			productName: data[id].productName,
			productPrice: data[id].productPrice,
			volumeValue: data[id].volumeValue,
			tipoDeEnvase: data[id].tipoDeEnvase,
			posicionArancelaria: data[id].posicionArancelaria,
			unidad: 'kg',
			countries: countries,
		});
	};

	return (
		<div className="price-comparator__container exporter-test__read-only">
			<div className="price-comparator__container-main">
				{!openProduct ? (
					<>
						<span className="price-comparator__container-title">{t('price_comparator.step_1.subtitle_3')}</span>

						<div className="comparator__container__body">
							<div className="exporter-test-information__container-footer">
								<div className="exporter-test-information__svg-icon-text-footern">
									<img
										src={avatar === 'women' ? AvatarWomen : AvatarMen}
										alt={avatar === 'women' ? 'avatar women' : 'avatar men'}
										className="rounded-circle"
										width={24}
										height={24}
									/>
								</div>
								<div
									className="globo_mensaje_custom-message rounded"
									style={{ backgroundColor: '#F4B400', width: '100%' }}>
									<span className="custom-message__text">{t('price_comparator.menu.message')}</span>
								</div>
							</div>

							<div className="boxes">
								<div
									className="boxes_item"
									onClick={() => handleChangeButton(0)}>
									<div className="boxes_item-img">
										<img
											src="assets/images/product01.png"
											alt=""
										/>
									</div>
									<div className="boxes_item-text">Frutos cubiertos con chocolate</div>
								</div>

								<div
									className="boxes_item"
									onClick={() => handleChangeButton(1)}>
									{!state?.isAuthenticated && (
										<div className="boxes_item-lock">
											<IconLock
												className="boxes_item-lock-svg"
												width={10}
												height={12}
												fill="#1A2228"
											/>
										</div>
									)}
									<div className="boxes_item-img">
										<img
											src="assets/images/product02.png"
											alt=""
										/>
									</div>
									<div className="boxes_item-text">Plant based Food (vegano)</div>
								</div>

								<div
									className="boxes_item"
									onClick={() => handleChangeButton(2)}>
									{!state?.isAuthenticated && (
										<div className="boxes_item-lock">
											<IconLock
												className="boxes_item-lock-svg"
												width={10}
												height={12}
												fill="#1A2228"
											/>
										</div>
									)}
									<div className="boxes_item-img">
										<img
											src="assets/images/product03.png"
											alt=""
										/>
									</div>
									<div className="boxes_item-text">Fideos sin gluten</div>
								</div>

								<div
									className="boxes_item"
									onClick={() => handleChangeButton(3)}>
									{!state?.isAuthenticated && (
										<div className="boxes_item-lock">
											<IconLock
												className="boxes_item-lock-svg"
												width={10}
												height={12}
												fill="#1A2228"
											/>
										</div>
									)}
									<div className="boxes_item-img">
										<img
											src="assets/images/product04.png"
											alt=""
										/>
									</div>
									<div className="boxes_item-text">Tabletas de chocolate</div>
								</div>

								<div
									className="boxes_item"
									onClick={() => handleChangeButton(4)}>
									{!state?.isAuthenticated && (
										<div className="boxes_item-lock">
											<IconLock
												className="boxes_item-lock-svg"
												width={10}
												height={12}
												fill="#1A2228"
											/>
										</div>
									)}
									<div className="boxes_item-img">
										<img
											src="assets/images/product05.png"
											alt=""
										/>
									</div>
									<div className="boxes_item-text">Mieles envasada</div>
								</div>

								<div
									className="boxes_item"
									onClick={() => handleChangeButton(5)}>
									{!state?.isAuthenticated && (
										<div className="boxes_item-lock">
											<IconLock
												className="boxes_item-lock-svg"
												width={10}
												height={12}
												fill="#1A2228"
											/>
										</div>
									)}
									<div className="boxes_item-img">
										<img
											src="assets/images/product06.png"
											alt=""
										/>
									</div>
									<div className="boxes_item-text">Salsas y aderezos (envasadas)</div>
								</div>
							</div>
						</div>
					</>
				) : (
					<>
						<span className="price-comparator__container-title">{t('price_comparator.step_1.subtitle_1')}</span>
						<div className="price-comparator___inner">
							<div className="price-comparator_grid">
								<div className="price-comparator__row ">
									<div className="col-12">
										<input
											type="text"
											className="price-comparator__textbox-general"
											placeholder={t('price_comparator.step_1.name.placeholder')}
											value={formData.productName || ''}
											onChange={(e) => handleChange('productName', e.target.value)}
											disabled
										/>
										{productNameError.length > 1 && (
											<div className="error-container">
												<InfoIcon fill="#F8A0D2" />
												<div className="error-message">{productNameError}</div>
											</div>
										)}
									</div>
								</div>
								<div className="price-comparator__row ">
									<div className="col-12 col-md-6">
										<input
											type="text"
											className="price-comparator__textbox-general-col1"
											placeholder={t('price_comparator.step_1.type.placeholder')}
											value={formData.tipoDeEnvase || ''}
											onChange={(e) => handleChange('tipoDeEnvase', e.target.value)}
											disabled
										/>
									</div>
									<div className="col-12 col-md-6">
										<input
											type="text"
											className="price-comparator__textbox-general-col2"
											placeholder={t('price_comparator.step_1.position.placeholder')}
											value={formData.posicionArancelaria || ''}
											onChange={(e) => handleChange('posicionArancelaria', e.target.value)}
											disabled
										/>
									</div>
								</div>
								<div className="price-comparator__row ">
									<div className="col-12 col-md-6 price-comparator__doble">
										<div className="price-comparator_select">
											<CustomizedSelect
												title={t('price_comparator.step_1.unit')}
												options={options__unidades}
												onChange={handleUnidadChange}
											/>
										</div>
										<div className="price-comparator_select_right">
											<input
												type="text"
												className="price-comparator__textbox-double-general-col"
												placeholder={t('price_comparator.step_1.volume.placeholder')}
												value={formData.volumeValue}
												onChange={(e) => handleChange('volumeValue', e.target.value)}
												disabled
											/>
										</div>
									</div>

									<div className="col-12 col-md-6">
										<div style={{ display: 'flex', flexDirection: 'column' }}>
											<input
												type="text"
												className="price-comparator__textbox-double-general-col2"
												placeholder={t('price_comparator.step_1.price.placeholder')}
												value={formData.productPrice}
												onChange={(e) => handleChange('productPrice', e.target.value)}
												disabled
											/>
										</div>
									</div>
								</div>

								{(volumeValueError.length > 1 || productPriceError.length > 1) && (
									<div className="row price-comparator__row mb-1">
										<div className="col-6">
											{volumeValueError.length > 1 && (
												<div className="error-container">
													<InfoIcon fill="#F8A0D2" />
													<div className="error-message">{volumeValueError}</div>
												</div>
											)}
										</div>
										<div className="col-6">
											{productPriceError.length > 1 && (
												<div className="error-container">
													<InfoIcon fill="#F8A0D2" />
													<div className="error-message">{productPriceError}</div>
												</div>
											)}
										</div>
									</div>
								)}
							</div>
							<div className="row price-comparator__row mb-1">
								<div className="col-12 col-md-6 offset-md-6 ">
									<Link
										to="/calcularprecios"
										className="price-comparator__container-link">
										{t('price_comparator.step_1.link')}
									</Link>
								</div>
							</div>
						</div>

						<span className="price-comparator__container-title">{t('price_comparator.step_1.subtitle_2')}</span>
						<div className="price-comparator___sub-inner">
							<div className="row">
								<div className="price-comparator__row mb-1">
									<div className="col-12">
										<div className="country-list">
											{countries.map((country) => {
												return <span className="country-item">{country}</span>;
											})}
										</div>
									</div>
								</div>
							</div>
						</div>

						{/* <div>
              <div className="price-comparator__btn" onClick={handleSubmit}>
                <div className="price-comparator__btn-text">{t('price_comparator.step_1.button')}</div>
              </div>
            </div> */}

						<div className="price-comparator__container-footer">
							<button
								className="price-calculator__footer-link"
								onClick={handleClickOpen}>
								{t('price_calculator.footer.link')}
							</button>
							<div
								className="price-comparator__btn"
								onClick={handleSubmit}>
								<div className="price-comparator__btn-text">{t('price_comparator.step_1.button')}</div>
							</div>
						</div>
					</>
				)}
			</div>
			{showLoginPopup && (
				<PopUp
					classes="popup-login"
					onClose={() => setShowLoginPopup(false)}
					isOpen={showLoginPopup}>
					<Login
						onLoginSuccess={() => {
							setShowLoginPopup(false);
						}}
					/>
				</PopUp>
			)}
			{showLoginRequiredPopup && (
				<PopUp
					classes="popup-login-required"
					onClose={() => setShowLoginRequiredPopup(false)}
					isOpen={showLoginRequiredPopup}>
					<div className="login-required-container">
						<div className="login-required-container__icon">
							<IconUserLogged />
						</div>
						<h3 className="login-required-container__title">{t('price_comparator.login_required.title')}</h3>
						<p className="login-required-container__message">{t('price_comparator.login_required.message')}</p>
						<button
							className="login-required-container__button"
							onClick={() => {
								setShowLoginRequiredPopup(false);
								setShowLoginPopup(true);
							}}>
							<div className="login-required-container__button-text">{t('price_comparator.login_required.button')}</div>
						</button>
					</div>
				</PopUp>
			)}
		</div>
	);
};

export default PriceComparatorForm;
